import { AxiosError } from "axios";
import { usePaystackPayment } from "react-paystack";
import { PaystackProps } from "react-paystack/dist/types";
import { toast } from "react-toastify";
import useResources from "./resourcesHook";
import useModal from "./modalHook";
import { COMPANY_EXPENSE_TYPE, PAYABLES, PAYMENT_MODES, PAYMENT_SERVICES } from "../resources/enums";
import { IPaymentData, IRequestErrorResponse, IVerifyPaymentDTO } from "../resources/interfaces";
import PaymentComplete from "../components/PaymentComplete";
import ToastContent from "../components/ToastContent";
import PaymentLinkModal from "../views/payments/PaymentLinkModal";
import Paystack from '@paystack/inline-js';
import { verifyPaymentRequest } from "../api/requests";
import { CompanyPayment } from "../resources/types";

interface IProps {
    onPaymentProcessed?: (payment: CompanyPayment) => void
}

function usePayments(props: IProps) {
    const { shareContent } = useResources();

    const { updateModalStates, ModalComponent, closeModal } = useModal();

    const PaymentModalComponent = ModalComponent;
    const PAYSTACK_KEY = process.env.REACT_APP_PAYSTACK_KEY;

    // const initializePaystackPayment = usePaystackPayment(props.paystackConfig);

    const choosePaymentMethod = (
        phone: string,
        showMomoForm?: boolean,
        resourceType?: COMPANY_EXPENSE_TYPE,
        paymentService?: PAYMENT_SERVICES,
    ) => {
        // initializePaystackPayment(onPaymentSuccessful, onClose);
        // if (phone) {
        //     switch (country?.iso) {
        //         case "GH":
        //             updateModalStates({
        //                 show: true,
        //                 size: "md",
        //                 children: (
        //                     <ChoosePaymentMethod
        //                         phone={phone}
        //                         showMomoForm={showMomoForm}
        //                         onProceed={(
        //                             paymentMethod: PAYMENT_OPTIONS,
        //                             data?: { phone: string; network: MOBILE_MONEY_NETWORKS }
        //                         ) => {
        //                             const paymentData: IPolicyPaymentData = {
        //                                 accountNumber: data?.phone ?? "",
        //                                 initialAmount: policyData.initialAmount,
        //                                 network: data?.network ?? "",
        //                                 policyNumber: policyData.policyNumber,
        //                                 recurringAmount: policyData.recurringAmount,
        //                                 discountCode: policyData.discountCode,
        //                                 isFullPayment: policyData.isFullPayment,
        //                                 isAutoPolicy: policyData.isAutoPolicy ?? true,
        //                             };

        //                             const _resourceType = resourceType
        //                                 ? resourceType
        //                                 : showMomoForm
        //                                     ? PAYMENT_RESOURCE_TYPE.HAILING_SERVICES
        //                                     : PAYMENT_RESOURCE_TYPE.AUTO_POLICY;
        //                             handlePayment(
        //                                 paymentMethod,
        //                                 data?.phone ?? "",
        //                                 paymentData,
        //                                 _resourceType
        //                             );
        //                         }}
        //                         policyData={policyData}
        //                         paymentService={defaultPaymentService}
        //                         publicPayment={props.publicPayment}
        //                     />
        //                 ),
        //             });
        //         case "NG":
        //             initializePaystackPayment(onPaymentSuccessful, onClose);
        //             break;
        //         default:
        //             updateModalStates({
        //                 show: true,
        //                 size: "md",
        //                 children: (
        //                     <ChoosePaymentMethod
        //                         phone={phone}
        //                         showMomoForm={showMomoForm}
        //                         onProceed={(
        //                             paymentMethod: PAYMENT_OPTIONS,
        //                             data?: { phone: string; network: MOBILE_MONEY_NETWORKS }
        //                         ) => {
        //                             const paymentData: IPolicyPaymentData = {
        //                                 accountNumber: data?.phone ?? "",
        //                                 initialAmount: policyData.initialAmount,
        //                                 network: data?.network ?? "",
        //                                 policyNumber: policyData.policyNumber,
        //                                 recurringAmount: policyData.recurringAmount,
        //                                 discountCode: policyData.discountCode,
        //                                 isFullPayment: policyData.isFullPayment,
        //                                 isAutoPolicy: policyData.isAutoPolicy ?? true,
        //                             };

        //                             const _resourceType = resourceType
        //                                 ? resourceType
        //                                 : showMomoForm
        //                                     ? PAYMENT_RESOURCE_TYPE.HAILING_SERVICES
        //                                     : PAYMENT_RESOURCE_TYPE.AUTO_POLICY;
        //                             handlePayment(
        //                                 paymentMethod,
        //                                 data?.phone ?? "",
        //                                 paymentData,
        //                                 _resourceType
        //                             );
        //                         }}
        //                         policyData={policyData}
        //                         paymentService={defaultPaymentService}
        //                         publicPayment={props.publicPayment}
        //                     />
        //                 ),
        //             });
        //             break;
        //     }
        // }
    };

    // const initializeHubtel = ({
    //     phone,
    //     paymentData,
    //     resourceType,
    // }: {
    //     phone: string;
    //     paymentData: IPolicyPaymentData;
    //     resourceType: PAYMENT_RESOURCE_TYPE;
    // }) => {
    //     let url = "";
    //     if (resourceType === PAYMENT_RESOURCE_TYPE.AUTO_POLICY) {
    //         url = HUBTEL_RESOURCE_PAYMENT_LINKS.AUTO_POLICY;
    //     }

    //     if (resourceType === PAYMENT_RESOURCE_TYPE.HAILING_SERVICES) {
    //         url = HUBTEL_RESOURCE_PAYMENT_LINKS.HAILING_SERVICES;
    //     }

    //     if (resourceType === PAYMENT_RESOURCE_TYPE.HOME_POLICY) {
    //         url = HUBTEL_RESOURCE_PAYMENT_LINKS.HOME_POLICY;
    //     }

    //     const payload: InitiateHubtelPaymentDTO = {
    //         initialAmount: paymentData?.initialAmount,
    //         accountNumber: paymentData.accountNumber ?? "",
    //         network: paymentData.network ?? "",
    //         policyNumber: paymentData.policyNumber,
    //     };

    //     initiateHubtelPayment(payload, url).then((response: any) => {
    //         const payload: IverifyMobilePaymentDTO = {
    //             otpCode: response?.data?.otpPrefix,
    //             policyNumber: paymentData.policyNumber,
    //             recurringInvoiceId: response?.data?.recurringInvoiceId,
    //             requestId: response?.data?.requestId,
    //         };

    //         updateModalStates({
    //             show: true,
    //             children: (
    //                 <VerifyPaymentOTP
    //                     phone={phone}
    //                     data={payload}
    //                     onProceed={() => {
    //                         onPaymentSuccessful("hubtel", PAYMENT_OPTIONS.MOBILE_MONEY);
    //                     }}
    //                 />
    //             ),
    //         });
    //     });
    // };

    // const initializeHubtelPreapproval = ({ phone, paymentData, resourceType }: {
    //     phone: string;
    //     paymentData: IPolicyPaymentData;
    //     resourceType: PAYMENT_RESOURCE_TYPE;
    // }) => {
    //     let url = HUBTEL_RESOURCE_PAYMENT_LINKS.AUTO_HUBTEL_PREAPPROVAL;

    //     const payload: InitiateHubtelPreapprovalDTO = {
    //         channel: paymentData.network ?? "",
    //         msisdn: paymentData.accountNumber ?? "",
    //         policyNumber: paymentData.policyNumber,
    //     };

    //     initiateHubtelPreapproval(payload, url).then((response: any) => {
    //         const payload: IverifyMobilePaymentDTO = {
    //             otpCode: response?.data?.otpPrefix,
    //             policyNumber: paymentData.policyNumber,
    //             recurringInvoiceId: response?.data?.recurringInvoiceId,
    //             requestId: response?.data?.requestId,
    //         };

    //         if (response && response.data.verificationType === "OTP") {
    //             updateModalStates({
    //                 show: true,
    //                 children: (
    //                     <VerifyPaymentOTP
    //                         phone={phone}
    //                         data={payload}
    //                         onProceed={() => {
    //                             onPaymentSuccessful("hubtel", PAYMENT_OPTIONS.MOBILE_MONEY);
    //                         }}
    //                         preapproval={true}
    //                     />
    //                 ),
    //             });
    //         } else {
    //             toast.success("Payment preapproval has been initiated successfully.", {
    //                 autoClose: 3000,
    //             });
    //             onPaymentSuccessful("hubtel", PAYMENT_OPTIONS.MOBILE_MONEY);
    //         }
    //     });
    // };

    // const showPhoneVerificationModal = (phone: string) => {
    //     updateModalStates({
    //         show: true,
    //         size: "md",
    //         children: (
    //             <PhoneVerificationModal
    //                 policy={props.policy}
    //                 close={closeModal}
    //                 onProceed={() => {
    //                     initializeItConsortium({ phone: phone });
    //                     closeModal();
    //                 }}
    //                 phoneNumber={phone}
    //                 isCustomer={false}
    //             />
    //         ),
    //         showCloseButton: true,
    //         // classes: "!p-0 r-[5px]",
    //         static: true,
    //     });
    // };

    // const handlePayment = async (
    //     paymentMethod: PAYMENT_MODES,
    //     phone: string,
    //     paymentData: IPaymentData,
    //     resourceType: COMPANY_EXPENSE_TYPE,
    //     paymentService?: PAYMENT_SERVICES
    // ) => {
    const handlePayment = async (
        paymentData: IPaymentData,
        paymentService?: PAYMENT_SERVICES
    ) => {
        const popup = new Paystack();

        const defaultPaymentService =
            paymentService ?? PAYMENT_SERVICES.PAYSTACK;

        try {
            if (PAYSTACK_KEY) {
                console.log("launch paystack", paymentData);
                console.log("popup", popup);
                popup.newTransaction({
                    key: PAYSTACK_KEY,
                    email: paymentData.email,
                    amount: paymentData.amount * 100,
                    reference: paymentData.local_reference,
                    currency: "GHS",
                    subaccountCode: paymentData.paystack_code ?? "",
                    // metadata: paymentData.metadata,
                    metadata: {
                        custom_fields: [
                            {
                                display_name: "Payable",
                                variable_name: "payable",
                                value: paymentData.metadata.payable,
                            },
                            {
                                display_name: "Payable ID",
                                variable_name: "payable_id",
                                value: paymentData.metadata.payable_id,
                            },
                        ],
                    },
                    onSuccess(transaction) {
                        verifyPayment(
                            transaction.reference,
                            PAYMENT_SERVICES.PAYSTACK,
                            paymentData.metadata.payable,
                            paymentData.metadata.payable_id
                        )
                        // Optional
                        // Navigate to success page
                    },

                    onCancel() {
                        toast.info("Payment cancelled.");
                    }
                });
            }
        } catch (error: AxiosError | IRequestErrorResponse | any) {
            toast.error(error?.description, {
                autoClose: 5000,
            });
        }
    };

    const verifyPayment = (
        reference: string,
        provider: PAYMENT_SERVICES,
        payableType: PAYABLES,
        payableId: string
    ) => {
        const payload: IVerifyPaymentDTO = {
            local_reference: reference,
            provider: provider,
            payable: payableType,
            payable_id: payableId
        }
        verifyPaymentRequest(payload)
            .then((response: any) => {
                props.onPaymentProcessed?.(response);
                toast.success("Payment processed successfully")
            }).catch((error: any) => {
                toast.error(error.detail ?? error.description, { autoClose: 5000 })
            })
    }

    const onPaymentSuccessful = (paymentService = "paystack", type = PAYMENT_MODES.CARD) => {
        updateModalStates({
            show: true,
            children: <PaymentComplete type={paymentService} />,
            static: true,
            showCloseButton: false,
            size: "4xl",
        });
    };

    const onClose = () => { };

    // function showBankTransfer() {
    //     updateModalStates({
    //         show: true,
    //         children: (
    //             <BankTransfer onPayLater={() => payLater()} policy={props.policy} />
    //         ),
    //         static: true,
    //         showCloseButton: true,
    //         size: "4xl",
    //     });
    // }

    const payLater = () => {
        toast.info(
            <ToastContent
                title={"Policy Saved"}
                status="info"
                description="Policy saved as pending. Find it on the policies page to pay later."
            />
        );
        // router.replace(`/panel/${HASH}/policies`);
    };

    const payForSelectedObjects = async (selectedPayments: string[]) => {
        try {
            console.log("selected payments:", selectedPayments)
            const response = await payForSelectedObjects(selectedPayments)
            console.log(response)
        } catch (error) {

        }
    }

    const showPaymentLinkModal = (paymentLink: string) => {
        updateModalStates({
            show: true,
            size: 'lg',
            children: (
                <PaymentLinkModal
                    onProceed={() => {
                        closeModal();
                    }}
                    onClose={closeModal}
                    link={paymentLink}
                />
            ),
            showTitleSection: false,
            classes: '!p-0 r-[5px]'
        });
    };

    return {
        handlePayment,
        PaymentModalComponent,
        choosePaymentMethod,
        payForSelectedObjects,
        showPaymentLinkModal, 
        verifyPayment
    };
}

export default usePayments;
